G.CommonObjects = G.CommonObjects || {};

G.CommonObjects.ClockTimer = function (x, y) {
  Phaser.Group.call(this, game);
  this.position.setTo(x, y);

  this.bg = G.makeImage(0, 0, 'timer_bar', 0.5, this);
  this.text = this.add(new G.Text(27, 2, '??d ??h ??m', {
    style: 'font-white',
    fontSize: 25,
  }, 0.5, 100));

  this.active = false;
  this.secLeft = 0;

  G.sb('onWallClockTimeUpdate').add(this._onTick, this);
};

G.CommonObjects.ClockTimer.prototype = Object.create(Phaser.Group.prototype);

G.CommonObjects.ClockTimer.prototype.setEndDate = function (timeStamp, start) {
  this.secLeft = Math.floor((timeStamp - Date.now()) / 1000);
  this.updateText(this.secLeft);
  if (start) this.start();
};

G.CommonObjects.ClockTimer.prototype.start = function () {
  if (this.secLeft > 0) {
    this.active = true;
    this.updateText(this.secLeft);
    return true;
  }
  return false;
};

G.CommonObjects.ClockTimer.prototype._onTick = function () {
  if (!this.active) return;

  this.secLeft--;
  this.updateText(this.secLeft);

  if (this.secLeft === 0) {
    this.active = false;
  }
};

G.CommonObjects.ClockTimer.prototype.updateText = function (secLeft) {
  const dhms = G.changeSecToDHMS(secLeft);
  const str = `${dhms[0]}d ${dhms[1]}h ${dhms[2]}m`;
  if (this.text.text !== str) {
    this.text.setText(str);
  }
};
